import { useTranslation } from 'react-i18next';

export const useTranslate = () => {
  const { t } = useTranslation('common');

  return {
    t: (key: string, options?: Record<string, unknown>) => {
      // Access translations from the nested checkout path
      // The structure is: common.checkout.key
      return t(`checkout.${key}`, options);
    },
  };
};
